module.exports = __webpack_public_path__ + "static/media/afl_everyday_digital_and_weekend_papers.ceadd738.png";